import { UNSAFE_expValEqualsNoExposure } from '@confluence/feature-experiments';
import { StatsigConfigurations } from '@confluence/statsig-configurations/entry-points/StatsigConfigurations.ts';

import { FORGE_MODULE_PAGE_BANNER } from './ForgeModuleType.ts';
import { getConfiguredMantraNavigationHeight } from './hooks/getMantraNavigationHeight.ts';
import { preloadUseExtensionList } from './hooks/preloadUseExtensionList.ts';

export const preloadHomePageBanner = async (cloudId: string): Promise<void> => {
	if (
		// oxlint-disable-next-line check-react-ssr-usage/no-react-ssr -- Preload only; SSR and hydration consume the same saved discovery.
		process.env.REACT_SSR &&
		getConfiguredMantraNavigationHeight(
			StatsigConfigurations.getString('cc_mantra_navigation_tenant_heights', ''),
			cloudId,
		) > 0 &&
		UNSAFE_expValEqualsNoExposure('cc_mantra_navigation_height', 'isEnabled', true)
	) {
		// Home has no page or space context. Publish discovery before MainLayout renders,
		// so SSR and hydration use the same banner list to reserve Mantra's height.
		await preloadUseExtensionList({ moduleType: FORGE_MODULE_PAGE_BANNER });
	}
};
